import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import "./usersIcon.css";

const UsersIcon = (props) => {
  const { style } = props;
  return <FontAwesomeIcon style={style} icon={faUsers} />;
};

export default UsersIcon;
